import {
    SET_FAMILY_MEMBERS,
    GET_FAMILY_MEMBERS,
    UPDATE_FAMILY_MEMBER,
    DELETE_FAMILY_MEMBER,
    FAMILY_MEMBERS_LOADING,
    FAMILY_MEMBERS_ERROR,
    CLEAR_FAMILY_MEMBERS
  } from '../actions/types';
  
  const initialState = {
    members: [],
    loading: false,
    error: null
  };
  
  export default function familyMembersReducer(state = initialState, action) {
    switch (action.type) {
      case FAMILY_MEMBERS_LOADING:
        return {
          ...state,
          loading: true,
          error: null
        };
        
      case GET_FAMILY_MEMBERS:
        return {
          ...state,
          members: action.payload,
          loading: false,
          error: null
        };
        
      case SET_FAMILY_MEMBERS:
        return {
          ...state,
          members: [...state.members, ...action.payload],
          loading: false,
          error: null
        };
        
      case UPDATE_FAMILY_MEMBER:
        return {
          ...state,
          members: state.members.map(member =>
            member._id === action.payload._id ? action.payload : member
          ),
          loading: false,
          error: null
        };
        
      case DELETE_FAMILY_MEMBER:
        return {
          ...state,
          members: state.members.filter(member => member._id !== action.payload),
          loading: false,
          error: null
        };
        
      case FAMILY_MEMBERS_ERROR:
        return {
          ...state,
          loading: false,
          error: action.payload
        };
        
      case CLEAR_FAMILY_MEMBERS:
        return {
          ...state,
          loading: false,
          error: null
        };
        
      default:
        return state;
    }
  }